export { gt as default } from "@ember/helper";
